module.exports = __webpack_public_path__ + "assets/historico.f54df762bebb89487f0849493afd9781.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/historico.png
// module id = 884
// module chunks = 0